import React from "react";

import { Chip } from "@performyard/py-components";
import { SurveyModel } from "@performyard/service-contracts";

export const getStatusChip = (surveyStatus: SurveyModel["status"]) => {
	switch (surveyStatus) {
		case "closed":
			return <Chip label="Closed" color="green" size={24} />;
		case "active":
			return <Chip label="Open" color="primary" size={24} />;
		case "draft":
			return <Chip label="Draft" color="neutral" size={24} />;
		case "scheduled":
			return <Chip label="Scheduled" color="yellow" size={24} />;
		default:
			return null;
	}
};
